import { storeToRefs } from "pinia";
import { shoppingCartStore } from "@stores/shopping_cart_store.js";
import Swal from "sweetalert2";
import {
  encriptar,
  desencriptar,
  encriptarCampo,
} from "@composables/use_encript.js";
import { useRouter } from "vue-router";
export const useShoppingCartStore = () => {
  const myShoppingCartStore = shoppingCartStore();

  const router = useRouter();

  const {
    loadingShoppingCart,
    showShoppingCart,
    shoppingCartItems,
    shoppingCartItemCount,
    shoppingCartTotal,
    idVenta,
    tipoPago,
    preferenceId,
    showCancelarVenta,
  } = storeToRefs(myShoppingCartStore);

  const initShoppingCart = async () => {
    await myShoppingCartStore.initShoppingCart();
  };

  const expiredCheck = async () => {
    await myShoppingCartStore.expiredCheck();
  };

  const toggleShoppingCartModal = () => {
    myShoppingCartStore.toggleShoppingCartModal();
  };

  const showShoppingCartModal = () => {
    myShoppingCartStore.showShoppingCartModal();
  };

  const hideShoppingCartModal = () => {
    myShoppingCartStore.hideShoppingCartModal();
  };

  const resetShoppingCart = async () => {
    await myShoppingCartStore.resetShoppingCart();
  };

  const addToShoppingCart = async (product) => {
    await myShoppingCartStore.addToShoppingCart(product);
    await myShoppingCartStore.updateData();
  };

  const removeFromShoppingCart = async (product) => {
    await myShoppingCartStore.removeFromShoppingCart(product);
    await myShoppingCartStore.updateData();

    if (shoppingCartItems.value.length == 0) {
      myShoppingCartStore.hideShoppingCartModal();
    }
  };

  const updateShoppingCart = async (
    product,
    qtty,
    ppId,
    Presentacion,
    PreciosPresentacion
  ) => {
    await myShoppingCartStore.updateShoppingCart(
      product,
      qtty,
      ppId,
      Presentacion,
      PreciosPresentacion
    );
    await myShoppingCartStore.updateData();
    //cartel de disponibilidad
    let availables = document.querySelectorAll(".available_vw");
    let showed = 0;
    availables.forEach((item) => {
      const el = document.getElementById(`ava_${item.dataset.ppId}`);
      const elParentElement = el.parentElement;
      const estilo = window.getComputedStyle(el);
      const estiloParentElement = window.getComputedStyle(elParentElement);
      if (estiloParentElement.display !== "none" && estilo.display !== "none") {
        showed++;
      }
    });

    if (showed == 0) {
      document.getElementById("msgNoDisponibilidad")?.classList.add("d-none");
    } else {
      document
        .getElementById("msgNoDisponibilidad")
        ?.classList.remove("d-none");
    }
  };

  const validateProduct = async (data) => {
    let itemVerified = await myShoppingCartStore.validateProduct(data);
    return itemVerified;
  };

  const ensureCheckoutId = () => {
    const actual =
      desencriptar(localStorage.getItem(encriptarCampo("checkoutId"))) || "";
    if (actual) return actual;
    const id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : "ck-" + Date.now() + "-" + Math.random().toString(16).slice(2);
    localStorage.setItem(encriptarCampo("checkoutId"), encriptar(id));
    return id;
  };

  const clearCheckoutId = () => {
    localStorage.setItem(encriptarCampo("checkoutId"), encriptar(""));
  };

  const soltarBotonesPago = () => {
    document.getElementById("btnMP")?.classList.remove("disabled");
    document.getElementById("btnOtrosPagos")?.classList.remove("disabled");
  };

  const processCart = async (data) => {
    initShoppingCart();
    data.checkoutId = ensureCheckoutId();
    document.getElementById("btnMP")?.classList.add("disabled");
    document.getElementById("btnOtrosPagos")?.classList.add("disabled");
    try {
      await correrCheckout(data);
    } finally {
      soltarBotonesPago();
    }
  };

  const correrCheckout = async (data) => {
    var preferenceId_value =
      desencriptar(localStorage.getItem(encriptarCampo("preferenceId"))) !== ""
        ? desencriptar(localStorage.getItem(encriptarCampo("preferenceId")))
        : "";
    if (preferenceId_value == "") {
      let response = await chequearStock(data);
      if (response) {
        await modalPagos(data);
      }
    } else {
      let cartModified =
        desencriptar(localStorage.getItem(encriptarCampo("cartModified"))) !==
          ""
          ? desencriptar(localStorage.getItem(encriptarCampo("cartModified")))
          : "false";
      let idVenta =
        desencriptar(localStorage.getItem(encriptarCampo("saleId"))) !== ""
          ? desencriptar(localStorage.getItem(encriptarCampo("saleId")))
          : "";
      if (cartModified == "true") {
        alert(
          "El Carrito de compras ha sido modificado, procediendo a actualizar la venta"
        );
        let response = await chequearStock(data);
        if (response) {
          await modalPagos(data, idVenta);
        }
        localStorage.setItem(
          encriptarCampo("cartModified"),
          encriptar("false")
        );
      } else {
        await modalPagos(data);
      }
    }
  };

  const chequearStock = async (data) => {
    document.getElementById("btnMP").classList.add("disabled");
    document.getElementById("btnOtrosPagos").classList.add("disabled");

    let itemVerified = await myShoppingCartStore.processCart(data);

    if (itemVerified) {
      let valid = true;
      itemVerified.forEach((item) => {
        if (item.isEnough == false) {
          valid = false;
        }
      });
      if (valid) {
        document.getElementById("loadingText").innerHTML =
          "Chequeo de disponibilidad de productos realizada. Procediendo a realizar la venta.";
        document.getElementById("msgNoDisponibilidad").classList.add("hidden");
        document.getElementById("msgNoDisponibilidad").classList.add("d-none");
        return true;
      } else {
        const box = document.getElementById("msgNoDisponibilidad");
        box.classList.remove("hidden");
        box.classList.remove("d-none");
        const texto = box.querySelector("p");
        if (texto) {
          texto.textContent =
            "No hay suficiente stock de algunos productos. Revisá los marcados en amarillo y bajá la cantidad al máximo indicado.";
        }
        document.getElementById("loadingText").innerHTML =
          "No hay suficiente stock para completar la compra.";
        await myShoppingCartStore.mostrarDisponibilidad(itemVerified);
        return false;
      }
    } else {
      return false;
    }
  };

  const modalPagos = async (data, idVenta = "") => {
    var tipoPago = data.tipoPago;
    if (tipoPago == "OtrosMedios") {
      return Swal.fire({
        title: "Método de Pago",
        text: "Al pagar en efectivo o por transferencia, te estaremos contactando para verificar el pago, antes de entregarte la compra.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dd2736",
        cancelButtonColor: "#000000",
        confirmButtonText: "Pagar en efectivo o transferencia",
        cancelButtonText: "Cancelar",
        didOpen: () => {
          const confirmButton = Swal.getConfirmButton();
          if (confirmButton) {
            confirmButton.addEventListener("click", () => {
              confirmButton.disabled = true;
              confirmButton.style.opacity = "0.5";
              confirmButton.style.cursor = "not-allowed";
            });
          }
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          var preferenceId =
            desencriptar(
              localStorage.getItem(encriptarCampo("preferenceId"))
            ) !== ""
              ? desencriptar(
                localStorage.getItem(encriptarCampo("preferenceId"))
              )
              : "";
          var idVenta =
            desencriptar(localStorage.getItem(encriptarCampo("saleId"))) !== ""
              ? desencriptar(localStorage.getItem(encriptarCampo("saleId")))
              : "";
          var cartModified =
            desencriptar(localStorage.getItem(encriptarCampo("cartModified"))) !==
              ""
              ? desencriptar(
                  localStorage.getItem(encriptarCampo("cartModified"))
                )
              : "false";

          if (preferenceId != "") {
            //Cambiar metodo de pago
            if (
              confirm(
                "Tiene una venta por pagar con Mercado Pago, ¿está seguro(a) que desea cambiar el método de Pago?"
              )
            ) {
              var idVenta =
                desencriptar(localStorage.getItem(encriptarCampo("saleId"))) !==
                  ""
                  ? desencriptar(localStorage.getItem(encriptarCampo("saleId")))
                  : "";

              data = {
                email: getEmail(),
                ventaId: idVenta,
                tipoPago: "OtrosMedios",
              };

              cambiarMetodoPago(data);
            } else {
              restablecerLoadingBotones();
              return false;
            }
          } else if (idVenta != "" && cartModified == "true") {
            data.cliente = getCliente();
            data.email = getEmail();
            data.ventaId = idVenta;
            let response = await actualizarVenta(data);
            if (response) {
              cerrarCompraExitosa();
            }
          } else if (idVenta != "") {
            cerrarCompraExitosa();
          } else {
            data.cliente = getCliente();
            data.email = getEmail();

            let response = await nuevaVenta(data);

            if (response) {
              cerrarCompraExitosa();
            }
          }
        } else {
          restablecerLoadingBotones();
        }
      });
    } else {
      // MERCADO PAGO
      var preferenceId_value =
        desencriptar(localStorage.getItem(encriptarCampo("preferenceId"))) !==
          ""
          ? desencriptar(localStorage.getItem(encriptarCampo("preferenceId")))
          : "";

      idVenta =
        desencriptar(localStorage.getItem(encriptarCampo("saleId"))) !== ""
          ? desencriptar(localStorage.getItem(encriptarCampo("saleId")))
          : "";
      const cartModified =
        desencriptar(localStorage.getItem(encriptarCampo("cartModified"))) !==
          ""
          ? desencriptar(localStorage.getItem(encriptarCampo("cartModified")))
          : "false";

      if (idVenta != "" && cartModified == "true") {
        data.cliente = getCliente();
        data.email = getEmail();
        data.ventaId = idVenta;
        let response = await actualizarVenta(data);
        if (response) {
          localStorage.setItem(
            encriptarCampo("cartModified"),
            encriptar("false")
          );
          await abrirPagoMercadoPago(data, response.data);
          restablecerLoadingBotones();
          return true;
        }
        return false;
      }
      if (preferenceId_value != "") {
        modalMercardoPago();
        await loadPayButtonGenerated(preferenceId_value);
        restablecerLoadingBotones();
        return true;
      }
      if (idVenta != "") {
        data.cliente = getCliente();
        data.email = getEmail();
        data.ventaId = idVenta;
        await abrirPagoMercadoPago(data, idVenta);
        restablecerLoadingBotones();
        return true;
      }

      data.cliente = getCliente();
      data.email = getEmail();
      let response = await nuevaVenta(data);
      if (response) {
        localStorage.setItem(
          encriptarCampo("saleId"),
          encriptar(String(response.data))
        );
        await abrirPagoMercadoPago(data, response.data);
        restablecerLoadingBotones();
        return true;
      }
      return false;
    }
  };

  const abrirPagoMercadoPago = async (data, ventaId) => {
    localStorage.setItem(encriptarCampo("saleId"), encriptar(String(ventaId)));
    modalMercardoPago();
    try {
      const preferenceId = await myShoppingCartStore.MPButtonPay(data, {
        data: ventaId,
      });
      if (preferenceId) {
        await myShoppingCartStore.resetShoppingCart();
      }
    } catch (e) {
      const loading = document.getElementById("loading");
      const loadingText = document.getElementById("loadingText");
      if (loading) loading.classList.remove("d-none");
      if (loadingText) {
        loadingText.innerHTML =
          "La venta quedó registrada. Reintentá para abrir el pago.";
      }
    }
  };

  const cerrarCompraExitosa = () => {
    Swal.fire({
      text: "Venta realizada exitosamente",
      confirmButtonColor: "#000000",
      icon: "success",
    });
    localStorage.setItem(
      encriptarCampo("basterShopingCart"),
      JSON.stringify(encriptar([]))
    );
    clearCheckoutId();
    myShoppingCartStore.toggleShoppingCartModal();
    const dominioURL = window.location.href;
    var soloPirotecnia = dominioURL.includes("?pirotecnia");
    if (soloPirotecnia) {
      router.push("/?pirotecnia");
    } else {
      router.push("/");
    }
  };

  const modalMercardoPago = () => {
    let htmlMessage =
      '<div id="divPagoMPModal" style="color: red; background-color: cornsilk"' +
      'class="text-left text-danger rounded p-1 mb-2">' +
      "<small>⏱️ Retiro del pedido<br/>" +
      "Una vez acreditado el pago, la preparación puede demorar entre 24 y 48 horas, según la demanda del momento." +
      "<br/>Cuando tu pedido esté listo para retirar, un asistente se comunicará con vos para confirmarlo." +
      "</small>" +
      '<div id="spinnerModal"><div class="spinner-border mt-1 ml-2" role="status">' +
      '<span class="sr-only"></span></div><span class="small px-3"><em>Cargando enlace para el Pago</em></span></div>' +
      '<div class="py-2" id="mercadoPagoSpan" style="display: flex;flex-direction: column;align-items: center;justify-content: center;">' +
      '<form method="POST" class="text-center" id="payForm"></form>' +
      "</div>" +
      "</div>";

    Swal.fire({
      title: "Método de Pago",
      html: htmlMessage,
      icon: "warning",
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonColor: "#000000",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isDismissed) {
        var preferenceId =
          desencriptar(localStorage.getItem(encriptarCampo("preferenceId"))) !=
            ""
            ? desencriptar(localStorage.getItem(encriptarCampo("preferenceId")))
            : "";

        if (preferenceId != "") {
          let btnCancelarVenta = document.getElementById("btnCancelarVenta");
          if (!btnCancelarVenta) {
            let btnCancelarVentaDimissed = document.getElementById(
              "btnCancelarVentaDimissed"
            );
            if (btnCancelarVentaDimissed) {
              btnCancelarVentaDimissed.classList.remove("d-none");
            }
          }
        }
        return false;
      }
    });
  };

  const loadPayButtonGenerated = async (preferenceId) => {
    const mlScript = document.createElement("script");
    mlScript.dataset.preferenceId = preferenceId;
    mlScript.src =
      "https://www.mercadopago.com.ar/integrations/v1/web-payment-checkout.js";
    document.querySelector("#payForm").append(mlScript);
    mlScript.addEventListener("load", () => {
      const spinner = document.getElementById("spinnerModal");
      if (spinner) spinner.classList.add("d-none");
    });
  };

  const nuevaVenta = async (data) => {
    return await myShoppingCartStore.nuevaVenta(data);
  };

  const actualizarVenta = async (data) => {
    return await myShoppingCartStore.actualizarVenta(data);
  };

  const setTipoPago = () => {
    myShoppingCartStore.setTipoPago(data);
  };

  const getCliente = () => {
    if (typeof Storage !== undefined) {
      return desencriptar(localStorage.getItem(encriptarCampo("cliente"))) !==
        ""
        ? desencriptar(localStorage.getItem(encriptarCampo("cliente")))
        : null;
    } else {
      return alert("Almacenamiento local no disponible!!!");
    }
  };

  const getEmail = () => {
    if (typeof Storage !== undefined) {
      return desencriptar(localStorage.getItem(encriptarCampo("email"))) !== ""
        ? desencriptar(localStorage.getItem(encriptarCampo("email")))
        : null;
    } else {
      return alert("Almacenamiento local no disponible!!!");
    }
  };

  const restablecerLoadingBotones = () => {
    document.getElementById("loading").classList.add("d-none");
    document.getElementById("loadingText").innerHTML = "";
    document.getElementById("btnMP").classList.remove("disabled");
    document.getElementById("btnOtrosPagos").classList.remove("disabled");

    let confirmBtn = document.querySelector(".swal2-confirm");
    if (confirmBtn) confirmBtn.classList.add("disabled");
  };

  const cancelarVenta = async (data) => {
    return await myShoppingCartStore.cancelarVenta(data);
  };

  const cambiarMetodoPago = async (data) => {
    let response = await myShoppingCartStore.cambiarMetodoPago(data);
    if (response) {
      alert("Compra " + response.id + " pagada con Otros Medios de Pago");
      myShoppingCartStore.setTipoPago("OtrosMedios");
      localStorage.setItem(
        encriptarCampo("basterShopingCart"),
        JSON.stringify(encriptar([]))
      );
      myShoppingCartStore.resetShoppingCart();
      const dominioURL = window.location.href;
      var soloPirotecnia = dominioURL.includes("?pirotecnia");
      if (soloPirotecnia) {
        router.push("/?pirotecnia");
      } else {
        router.push("/");
      }
    }
  };

  return {
    ///* properties
    loadingShoppingCart,
    showShoppingCart,
    shoppingCartItems,
    shoppingCartItemCount,
    shoppingCartTotal,
    idVenta,
    tipoPago,
    preferenceId,
    showCancelarVenta,

    ///* methods
    initShoppingCart,
    expiredCheck,
    toggleShoppingCartModal,
    showShoppingCartModal,
    hideShoppingCartModal,
    resetShoppingCart,
    addToShoppingCart,
    removeFromShoppingCart,
    updateShoppingCart,
    processCart,
    validateProduct,
    nuevaVenta,
    cancelarVenta,
    cambiarMetodoPago,
  };
};
